import { useId, useCallback, type FC } from "react";

import InputWithSuggestions from "@/components/podkit/forms/InputWithSuggestions";
import { Label } from "@/components/podkit/forms/Label";
import { type PropsWithClassName, cn } from "@/components/podkit/lib/cn";
import { useListContextUrls } from "@/hooks/use-context-url";
import { TrackLocations } from "@/hooks/use-segment";

type Props = {
    label?: string;
    value?: string;
    name?: string;
    disabled?: boolean;
    errorMessage?: string;
    autoFocus?: boolean;
    onChange?: (value: string) => void;
};
export const ContextUrlInput: FC<Props & PropsWithClassName> = ({
    label,
    value,
    onChange,
    name,
    disabled,
    className,
    errorMessage,
    autoFocus,
}) => {
    const { contextUrls } = useListContextUrls();
    const elId = useId();

    const handleChange = useCallback(
        (value: string) => {
            value = value.trim();
            if (onChange) {
                onChange(value);
            }
        },
        [onChange],
    );

    return (
        <div className={cn("flex items-center space-x-2", className)}>
            <div className="flex w-full flex-col gap-2">
                <Label htmlFor={elId} className="font-medium">
                    {label}
                </Label>
                <InputWithSuggestions
                    id={elId}
                    data-testid="context-url-input"
                    name={name}
                    value={value}
                    disabled={disabled}
                    suggestions={contextUrls || []}
                    placeholder="https://github.com/microsoft/vscode-remote-try-go"
                    onChange={handleChange}
                    error={errorMessage}
                    autoFocus={autoFocus}
                    data-track-location={TrackLocations.ContextUrlInput}
                />
            </div>
        </div>
    );
};
